import {
	Card,
	CardHeader,
	CardBody,
	withFilters,
	Button,
} from '@wordpress/components';
import { RawHTML } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import { lock } from '@wordpress/icons';

export const Promo = withFilters( 'popper.settings.promo' )( ( props ) => {
	const { message } = props;
	return (
		<Card>
			<CardHeader>
				<b>{ __( 'Popper PRO', 'popper' ) }</b>
			</CardHeader>

			<CardBody>
				<RawHTML>{ message }</RawHTML>
				<Button
					variant="primary"
					href="https://www.popperwp.com/"
					icon={ lock }
					iconPosition={ 'left' }
					target="_blank"
				>
					{ __( 'Try it now!', 'popper' ) }
				</Button>
			</CardBody>
		</Card>
	);
} );
